<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <Loading v-if="loading"/>
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
           
        </section>
        
        <section class="section section-lg pt-lg-0  mt--400">             
            <div class="container card card-profile shadow p-3 ">
                <div class="row justify-content-center mb-5">
                    <div class="col-lg-4 order-lg-2">
                        <div class="card-profile-image">
                            <a href="#">
                                <img v-lazy="'img/user.png'" class="rounded-circle bg-white">
                            </a>
                        </div>
                        
                    </div>
                    <div class="col-4 order-lg-3 text-lg-right align-self-lg-center">
                        <div class="card-profile-actions mt-0">
                            <b-form >
                                <b-form-input
                                    style="border:none;border-bottom: 1px solid #8898aa;outline: none;"
                                    v-model="search"
                                    placeholder="Search for champion"
                                    
                                ></b-form-input>
                                
                            </b-form>
                        </div>
                    </div>
                    <div class="col-lg-4 order-lg-1">
                        <div class="card-profile-stats d-flex justify-content-center">
                            <h2 class="col-12 text-center font-weight-bold">CHAMPIONS</h2>
                            
                        </div>

                        <div class=" d-flex justify-content-center">

                        <base-button @click="upload = !upload" type="primary" :icon="!upload ? 'fa fa-plus' : 'fa fa-minus'"></base-button>
                        </div>
                    </div>
                </div>

                <div class="card shadow rounded d-flex my-2 mx-3 p-5"  v-if="upload"> 
                    <div class="card-title text-center">
                        Upload Champions
                    </div>                            
                    <!-- <vue-dropzone  ref="myVueDropzone" @vdropzone-complete="afterComplete($event)" id="dropzone" :options="dropzoneOptions" ></vue-dropzone> -->
                    <div class="row d-flex justify-content-center rounded">
                        <input class="form-control col-6 mb-3" type="file" v-if="!jsondata.rows"  @change="afterComplete($event)"/>
                    
                        <div class="col-12"  v-if="jsondata.errors" >
                            <base-alert type="warning" v-for="error in jsondata.errors" :key="error.row+error.column">                                        
                                <strong>Error!</strong>  The field {{ error.column }} is {{ error.error }} on row {{ error.row }}
                            </base-alert>
                        </div>
                        <div class="col-12"  v-if="error" >
                            <base-alert type="warning" v-for="error in error" :key="error.row+error.column">                                        
                                    <strong>Error!</strong>  The field {{ error.column }} is {{ error.error }} on row {{ error.row }}
                            </base-alert>
                        </div>
                        <div v-if="jsondata.rows" class="text-center">
                            <vue-excel-editor ref="grid"  class="col-12 text-center my-3" :no-paging="true" :validate="validWholeRecord"  v-model="jsondata.rows" :no-header-edit="true" :disable-panel-filter="true" :disable-panel-setting="true">
                                <vue-excel-column width="200px" :sort="nosorting"  field="Name"        label="Staff Name"     :validate="validName" />
                                <vue-excel-column width="200px" :sort="nosorting"  field="Phone"       label="Mobile Number"  :validate="validMobile" />
                                <vue-excel-column width="200px" :sort="nosorting"  field="Email"       label="Company Email"  :validate="validEmail"/>
                                <vue-excel-column width="200px" :sort="nosorting"  field="StaffNumber" label="Staff Number" />
                            </vue-excel-editor>
                            <base-button class="btn-tooltip" type="primary" v-b-tooltip.hover.right :title="error.length > 0 || jsondata.errors.length > 0 ? 'clear errors before upload':'upload champions'" :disabled="error.length > 0 || jsondata.errors.length > 0" >Upload</base-button>
                        </div>                            
                        
                    </div>
                    
                </div>
                
                <div v-for="user in filteredSearch" :key="user.TaskID" class="card shadow col-12 p-3 mb-5 border-primary border-right" style="border-radius:20px; !important;border:none;border-width:6px !important;">
                                                    
                    <div class="card-content">                                    
                        <div class="row text-center">
                            <div class="col">
                                <img src="/img/face.png" style="max-width: 70px; !important" class="rounded-circle bg-white">
                                
                                <div>56</div>
                                <p><b>Present Count</b></p>
                                
                            </div>
                                <div class="col mt-auto mb-auto">

                                <p class="font-weight-bold">Wambui Njage</p>
                                <div>56</div>
                                <b>Late Count</b>
                            
                                </div>

                                <div class="col mt-auto mb-auto">
                                    <p>Tech Team</p>
                                <div>8:30 am</div>
                                <b>Average Arrivial</b>
                                </div>

                                <div class="my-auto">
                                    <base-button type="warning" icon="fa fa-trash"></base-button>
                                
                                    <base-button type="primary" icon="fa fa-pencil"></base-button>
                                
                                    <base-button type="info" icon="fa fa-close"></base-button>
                                </div>
                        
                        </div>                             
                    </div>
                    
                </div>                    
            </div>
        </section>
        
    </div>
</template>
<script>
import BaseButton from '../components/BaseButton.vue';
import Loading from './Loading'
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
import {XlsxRead, XlsxTable, XlsxJson} from "../../node_modules/vue-xlsx/dist/vue-xlsx.es.js"
import readXlsxFile from 'read-excel-file'
import convertToJson from "read-excel-file/schema"


export default {
     components: { 
         Loading,
         LottieAnimation,
         BaseButton,
         XlsxRead,
         XlsxJson,
         XlsxTable,
         
     },
     data(){
         return{
             loading:false,
             upload:false,
             error:[],
             msg:'',
             jsondata:{},
             search:'',
             file:'',
             users:this.$store.state.tasks,
             schema : {
                'Name': {
                    prop: 'Name',
                    type: String,
                    required:true
                },
                'Phone': {
                    prop: 'Phone',
                    required:true,
                    type: (value) => {
                    
                    if (!/^(2547)[0-9]{8}$/.test(value)) {
                        throw new Error('invalid it must start with 2547xxxxxxxx and be 12 digits')
                    }
                    return value
                    }
                },
                'Email': {
                    prop: 'Email',
                    type: (value) => {
                    
                    if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value)) {
                        throw new Error('invalid')
                    }
                    return value
                    },
                    required:true
                },
                'StaffNumber': {
                    prop: 'StaffNumber',
                    type: String
                },
                
             }

         }
     },

      computed:{
            filteredSearch : function(){
                return this.users.filter( user =>{
                        return user.TaskName.toLowerCase().includes(this.search.toLowerCase())
                })  
            },
        },

     methods:{
            nosorting() {
                return false 
            },
           
            validEmail (content, oldContent, record, field) {

                const emaitest = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(content)

                if (content === '' || !'Email' in record || !emaitest) {

                     this.jsondata.rows.filter( (row,index) => {
                        var result = this.jsondata.errors.find(obj => {
                        return obj.row === index+1 && obj.column == field.name
                        })

                        if(row === record && result.length === 0){

                            this.error.push({
                                row:index+1,
                                column:field.name,
                                error:"required"
                            })
                            
                        }
                      })

                     return 'Mandatory field / invalid email address format'

                }else{

                    this.jsondata.rows.filter( (row,index) => {

                    if(row === record){
                        this.error = this.error.filter(item => item.row !== index+1);                         
                    }
                })


                 return ''
                }
            
            },

            validMobile (content, oldContent, record, field) {

                const mobiletest = /^(2547)[0-9]{8}$/.test(content)

                if (content === '' || !'Phone' in record || !mobiletest) {
                     this.jsondata.rows.filter( (row,index) => {

                        var result = this.jsondata.errors.find(obj => {
                            return obj.row === index+1 && obj.column == field.name
                        })

                        var olderror = this.error.find(obj => {
                          return obj.row === index+1 && obj.column == field.name
                        })

                        if(row === record && !result && !olderror){

                            this.error.push({
                                row:index+1,
                                column:field.name,
                                error:"required"
                            })
                            
                        }
                     })

                     return 'Invalid phone no must start with 2547xxxxxxxx and be 12 digits'
                }else{

                    this.jsondata.rows.filter( (row,index) => {

                    if(row === record){
                        // console.log(this.error.filter(item => item.column != field.name))
                        this.error = this.error.filter(item => item.row !== index+1 && item.column != field.name);
                         
                    }
                })


                    return ''
                }
            
            },

            validName (content, oldContent, record, field) {

                if (content === '' || !'Name' in record) {
                     this.jsondata.rows.filter( (row,index) => {

                    if(row === record){

                        this.error.push({
                            row:index+1,
                            column:field.name,
                            error:"required"
                        })
                         
                    }
                })

                    return 'Mandatory field'
                }else{

                    this.jsondata.rows.filter( (row,index) => {

                    if(row === record){

                    this.error = this.error.filter(item => item.row !== index+1);
                         
                    }
                })


                    return ''
                }
            
            },

            validWholeRecord (content, oldContent, record, field) {
                
                if (field.name == 'undefined') return 'Mandatory field'

                if(field.name == "Phone"){
                     if (!/^(2547)[0-9]{8}$/.test(content)) return 'Invalid phone no must start with 2547xxxxxxxx and be 12 digits'
                }
                if(field.name == "Email"){
                     if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(content)) return 'Invalid phone no must start with 2547xxxxxxxx and be 12 digits'
                }

                this.jsondata.rows.filter( (row,index) => {

                    if(row === record){

                         this.jsondata.errors = this.jsondata.errors.filter(item => item.row !== index+1 && item.value != content);
                       
                    } 
                })
            },

            afterComplete(event) {             
                this.file = event.target.files[0]

                if (this.file) {

                    readXlsxFile(this.file).then((rows) => {

                        this.jsondata = convertToJson(rows, this.schema)
                                             
                    })
                 }
            }
     }
};
</script>
<style>
</style>
